/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { schedule } from '@ember/runloop';
import { capitalize } from '@ember/string';
/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject as service } from '@ember/service';
import { action, get, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
/* eslint-enable @typescript-eslint/no-unused-vars */
let FreestyleUsageControls = (_dec = service('ember-freestyle'), (_class = class FreestyleUsageControls extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "emberFreestyle", _descriptor, this);
    _defineProperty(this, "showHeader", true);
    _defineProperty(this, "showFocus", true);
    _initializerDefineProperty(this, "focus", _descriptor2, this);
  }
  get showLabels() {
    return this.emberFreestyle.showLabels;
  }
  set showLabels(val) {
    this.emberFreestyle.showLabels = val;
  }
  get showNotes() {
    return this.emberFreestyle.showNotes;
  }
  set showNotes(val) {
    this.emberFreestyle.showNotes = val;
  }
  get showCode() {
    return this.emberFreestyle.showCode;
  }
  set showCode(val) {
    this.emberFreestyle.showCode = val;
  }
  get showApi() {
    return this.emberFreestyle.showApi;
  }
  set showApi(val) {
    this.emberFreestyle.showApi = val;
  }
  setup() {
    schedule('afterRender', () => {
      this.focus = this.emberFreestyle.focus;
    });
  }
  toggleUsage(usageType) {
    const propName = `show${capitalize(usageType)}`;
    set(this.emberFreestyle, propName, !get(this.emberFreestyle, propName));
  }
  setFocus() {
    this.emberFreestyle.set('focus', this.focus);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "emberFreestyle", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "focus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleUsage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleUsage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFocus"), _class.prototype)), _class));
export { FreestyleUsageControls as default };